export default "__VITE_ASSET__BIN3GBO9__"